import { create } from 'zustand';

interface EpisodeListState {
  /** Ordered list of episode IDs from the most recent list query */
  episodeIds: string[];
  /** Update the episode ID list (called when the episodes page fetches data) */
  setEpisodeIds: (ids: string[]) => void;
}

export const useEpisodeListStore = create<EpisodeListState>((set) => ({
  episodeIds: [],
  setEpisodeIds: (ids: string[]) => set({ episodeIds: ids }),
}));
